var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialGoogle = function SvgSocialGoogle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 12.2025C20.9999 11.61 20.9463 11.0475 20.8543 10.5H12.1953V13.8825H17.1532C16.9309 14.9925 16.2796 15.93 15.3141 16.5675V18.8175H18.2719C20.0037 17.25 20.9999 14.94 20.9999 12.2025Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1952 21C14.6779 21 16.7546 20.19 18.2718 18.8175L15.314 16.5675C14.4864 17.1075 13.4366 17.4375 12.1952 17.4375C9.79671 17.4375 7.76606 15.855 7.03809 13.7175H3.98828V16.035C5.49786 18.975 8.60131 21 12.1952 21Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03831 13.7175C6.84674 13.1775 6.74713 12.6 6.74713 12C6.74713 11.4 6.85441 10.8225 7.03831 10.2825V7.96503H3.98851C3.36015 9.18003 3 10.545 3 12C3 13.455 3.36015 14.82 3.98851 16.035L7.03831 13.7175Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1952 6.5625C13.5515 6.5625 14.7622 7.02 15.7201 7.9125L18.3408 5.3475C16.7546 3.8925 14.6779 3 12.1952 3C8.60131 3 5.49786 5.025 3.98828 7.965L7.03809 10.2825C7.76606 8.145 9.79671 6.5625 12.1952 6.5625Z",
    fill: "#EA4335"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social-google.cafd6351b3a15dfb484be7e55b2cf7cc.svg";